/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_DescInputs */

const en_mk_team_flow_desc = /** @type {(inputs: Mk_Team_Flow_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select “Start agent team” when your plan is ready. Independent tasks can run together; dependent work follows its required order.`)
};

const id_mk_team_flow_desc = /** @type {(inputs: Mk_Team_Flow_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik “Mulai tim agent” setelah rencana siap. Tugas mandiri bisa berjalan bersamaan; pekerjaan yang saling bergantung tetap mengikuti urutan.`)
};

/**
* | output |
* | --- |
* | "Select “Start agent team” when your plan is ready. Independent tasks can run together; dependent work follows its required order." |
*
* @param {Mk_Team_Flow_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_desc = /** @type {((inputs?: Mk_Team_Flow_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_desc(inputs)
	return en_mk_team_flow_desc(inputs)
});